import { useTrans } from "@/translations";

import { twMerge } from "tailwind-merge";

import type { CardFilterOnChange, FilterOption } from "../types";

type Props = {
  option: FilterOption;
  isSelected: boolean;
  onSelectOption: CardFilterOnChange;
  largeView?: boolean;
};

export const CardFilterButton: React.FC<Props> = ({
  option,
  isSelected,
  onSelectOption,
  largeView,
}) => {
  const { t } = useTrans();

  return (
    <button
      onClick={() => onSelectOption(option.key)}
      className={twMerge(
        "cursor-pointer rounded-md px-[9px] py-[3px] text-[11.5px] font-medium whitespace-nowrap transition-colors",
        isSelected ? "bg-[#1D1C1C] font-semibold text-white" : "text-grey6",
        largeView && "px-[12px] py-[6px] text-[12.5px]",
      )}
    >
      {t(option.label)}
    </button>
  );
};
